import React from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'connected-react-router'
import { withRouter } from 'react-router-dom'
import configureStore, { history } from './store'
import App from './app'
import 'normalize.css'

const store = configureStore()

const renderRoot = (AppToRender) =>
    render(
        <Provider store={store}>
            <ConnectedRouter history={history}>
                <AppToRender />
            </ConnectedRouter>
        </Provider>,
        document.getElementById('root')
    )

renderRoot(withRouter(App))

//---Hot Module Replacement
if (module.hot) {
    module.hot.accept('./app', () => {
        const nextApp = require('./app').default
        renderRoot(withRouter(nextApp))
    })
}
